module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_2@2x.7a818636.png";